import DOMPurify from "dompurify";
import type { TAccordionProps } from "./types";

export const Accordion = ({ title, description }: TAccordionProps) => {
  const AccordionElement = document.createElement("details");
  AccordionElement.className = "flex flex-col group";

  AccordionElement.innerHTML = DOMPurify.sanitize(/* html */ `
    <summary class="cursor-pointer  p-6 font-medium text-lg text-gray-800 flex items-center justify-between">
      ${title}

      <img
        src="/static/icons/chevron-down.svg"
        alt="icon"
        class="group-open:rotate-180 transition-transform duration-300 ease-in-out object-contain"
      />
    </summary>
    <div class="px-6 pb-6">
      <p class=" text-xl text-gray-450">
        ${description}
      </p>
    </div>
  `);

  AccordionElement.addEventListener("toggle", () => {
    if (AccordionElement.open) {
      document.querySelectorAll("details").forEach((el) => {
        if (el !== AccordionElement) el.removeAttribute("open");
      });
    }
  });

  return AccordionElement;
};
